<template>
  <div>
    <div class="q_mar_b100px">
      <div class="q_pad_lr15px q_mar_t15px">
        <div class="q_vertical_left q_mar_b15px" @click="goToActivdea(userActivity.activityId)">
          <div class="q_inlineblock">
            <van-image class="q_signd_img" fit="cover" :src="convertImg(userActivity.activityBanner)"/>
          </div>
          <div class="q_mar_l15px q_inlineblock">
            <div class="q_text_m q_bold q_moit2 q_justify" v-text="userActivity.activityName">招远金太阳志愿者开展 “以爱之名
              携手同行”助残日志愿服务活动
            </div>
            <!--            <div class="q_text_s q_color_gray q_mar_t30px" v-text="userActivity.createTime">2022-04-18 08:00-17:00</div>-->
          </div>
        </div>
        <div class="q_text_l q_bold q_mar_t15px q_mar_b10px">报名进度</div>
      </div>
      <van-cell title="报名进度" :value="userActivity.state=='0'?'待审核':userActivity.state=='1'?'审核通过':'审核不通过'"/>
      <van-cell title="提交时间" :value="userActivity.createTime"/>
      <van-cell title="审核理由" :value="userActivity.reason" v-if="userActivity.state!='0'"/>
    </div>
    <van-goods-action>
      <van-goods-action-button type="danger" color="#ffffff" text="取消报名" @click="cancelApply"
                               v-if="userActivity.state=='0'"/>
      <van-goods-action-button type="success" color="#ffffff" text="活动详情" @click="goToActivdea(userActivity.activityId)"
                               v-if="userActivity.state=='1'"/>
    </van-goods-action>
  </div>
</template>

<script>
import {delUserActivity, getUserActivity} from "@/api/userActivity";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Signdea',
  props: {
    msg: String
  },
  created() {
    wxCloseShare()
    this.id = this.$route.query.id;
    this.init()
  },
  data() {
    return {
      id: '',
      userActivity: {activityBanner: ''}
    }
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.$modal.loading()
      //获取活动详情信息
      getUserActivity(this.id).then((res) => {
        this.userActivity = res.data
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    /**
     * 取消报名
     */
    cancelApply() {
      this.$modal.confirm("确定要取消报名吗？").then(() => {
        this.$modal.loading()
        delUserActivity(this.id).then(res => {
          this.$modal.success('取消成功')
        }).finally(() => {
          setTimeout(() => {
            this.$modal.closeLoading()
            this.$router.push({
              path: '/'
            });
          }, 1500);
        })
      })
    },
    goToActivdea(id) {
      this.$router.push({
        path: '/activity/Activdea/',
        query: {
          id: id
        }
      });
    },
  }
}
</script>
<style scoped="scoped">
.q_signd_img {
  width: 165.5px;
  height: 93.28px;
}

>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-goods-action-button {
  border: 1px solid #FF5733 !important;
  color: #FF5733 !important;
}

.van-cell::after {
  border: none;
}
</style>
